import { join } from 'light-component';
import { type ReactElement } from 'react';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { Box } from '../../../box';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import type { CalendarProps } from './types';

export function CalendarViewMode(props: CalendarProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <DatePicker
          disabled
          className={styles.datePicker}
          value={dayjs(props.value)}
          inputReadOnly={props.readonly === true}
        />
      </Box>
    </Box>
  );
}
